/**
 * Working around https://github.com/thednp/bootstrap.native/issues/351.
 * If the issue gets patched or if we stop using bootstrap.native we can remove this.
 */

const useElement = document.querySelector("use");

if (useElement) {
  try {
    Object.defineProperty(Object.getPrototypeOf(useElement.href), "slice", {
      value: () => "",
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
}
